// extracted by mini-css-extract-plugin
export default {"upsellRibbon":"upsell-ribbon-module__upsellRibbon___g0Pnp","overlayText":"upsell-ribbon-module__overlayText___H4ohG","button":"upsell-ribbon-module__button___XWAyJ"};